<div class="script-preferences-dialog">
  <div class="header">
    <pdq-heading element="h3">Are you sure?</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close(false)"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      Enabling custom scripts is an advanced action and should be taken with care. Consult your development team as
      needed to ensure proper configuration with your shop’s codebase. Read more about it in
      <pdq-link external="true" label="support center." url="https://support.prettydamnquick.com/en/"></pdq-link>
    </div>
  </div>
  <footer>
    <pdq-button label="Cancel" (onClick)="dialogRef.close(false)"></pdq-button>
    <pdq-button variant="primary" label="Confirm" (onClick)="confirm($event)"></pdq-button>
  </footer>
</div>
